import parse from 'html-react-parser';

function HtmlParser({ htmlString }) {
    return <>{parse(htmlString)}</>;
}

export default HtmlParser;
